//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProduct } from '@/api/jianianhua'
import config from '@/config'
export default {
  name: 'stamp',
  props: {},
  data () {
    return {
      page: 1,
      rows: 10,
      prolist: '',
      baseUrl: config.baseUrl,
      moremsg: '点击加载更多',
      nomre: false
    }
  },
  created () { },
  mounted () {
    this.getlist()
  },
  methods: {
    mine () {
      this.$router.push({ name: 'jianianhuamine' })
    },
    change (id) {
      this.$router.push({ name: 'jianianhuaconfirm', params: { productid: id } })
    },
    getlist () {
      getProduct({
        page: this.page,
        rows: this.rows
      }).then(data => {
        if (data.obj.length > 0) {
          this.prolist = [...this.prolist, ...data.obj]
          this.moremsg = '点击加载更多'
          this.nomore = false
          this.prolist.forEach((item, index) => {
            item.flag = this.compareDate(item.startdate, item.enddate) && this.compareTime('10:30', '16:30')
          })
        } else {
          this.moremsg = '没有更多了'
          this.nomore = true
        }
      })
    },
    compareTime (beginTime, endTime) {
      var strb = beginTime.split(':')
      if (strb.length !== 2) {
        return false
      }

      var stre = endTime.split(':')
      if (stre.length !== 2) {
        return false
      }

      var b = new Date()
      var e = new Date()
      var n = new Date()

      b.setHours(strb[0])
      b.setMinutes(strb[1])
      e.setHours(stre[0])
      e.setMinutes(stre[1])

      if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
        return true
      } else {
        return false
      }
    },
    compareDate (d1, d2) {
      var startDate = new Date(d1.replace(/-/g, '\/'))
      var currentDate = new Date()
      var enddate = new Date(d2.replace(/-/g, '\/'))
      return Date.parse(startDate) < Date.parse(currentDate) && Date.parse(currentDate) < Date.parse(enddate)
    },
    linkdetail (id) {
      this.$router.push({ name: 'jianianhuadetail', params: { id: id } })
    },
    loadmore () {
      if (!this.nomore) {
        this.moremsg = '加载中'
        this.page++
        this.getlist()
      }
    }
  }
}
